import React, { useEffect, useRef } from 'react';
import { Image, Text } from '@ui/atoms';
import texts from '@components/BondDirectoryFeature/en.json';
import useClickOutside from '@hooks/useClickOutside';
import { useRouter } from 'next/router';
import { useBondDirectoryContext } from '../context/bond-directory-context';

const BondsSearchBar = ({ isSearchIcon = true, children, id, ...props }) => {
    const searchRef = useRef(null);
    const router = useRouter();

    const {
        showResults,
        onChange,
        onFocus,
        handleGoBack,
        value,
        onClose,
        showSearchModal,
    } = useBondDirectoryContext(({ states, callbacks }) => ({
        showResults: states.showResultsPage,
        onChange: callbacks.handleOnChange,
        onFocus: callbacks.handleOnFocus,
        handleGoBack: callbacks.handleGoBack,
        value: states.searchQuery,
        onClose: callbacks.onCloseSearchModal,
        showSearchModal: states.showSearchModal,
    }));

    const handleClose = () => {
        onClose();
        if (showResults) return;
        handleGoBack();
    };

    const {
        bondSearch: { name, placeholder },
    } = texts;

    const handleOnChange = (e) => {
        onChange(e.target.value, e.target.value.length >= 3);
    };

    const handleOnFocus = (e) => {
        onFocus(e.target.value, e.target.value.length >= 3);
    };

    const handleOnBlur = () => {
        if (searchRef) {
            onChange(searchRef?.current?.value, false);
        }
    };

    useEffect(() => {
        if (searchRef.current && !isSearchIcon) {
            searchRef.current.focus();
        }
    }, [isSearchIcon]);

    const handleOnClear = (e) => {
        if (!e.target.value) {
            onChange('', false);
            router.replace(
                {
                    pathname: router.pathname,
                },
                undefined,
                { shallow: true }
            );
        }
    };

    useClickOutside(searchRef, handleOnBlur);

    return (
        <div className="relative flex-1 ">
            {showResults && !showSearchModal && (
                <>
                    <div
                        className="relative flex items-center mb-4 cursor-pointer md:hidden"
                        onClick={handleGoBack}
                    >
                        <Image
                            src="/icons/back-white.svg"
                            alt="back"
                            className="w-4 h-4 text-basicWhite"
                        />
                        <Text
                            content="Back"
                            className="ml-1 text-gray-200 p4-medium"
                        />
                    </div>
                    <Text
                        content="Search Bond"
                        className="mb-2 md:hidden text-basicWhite p4-medium"
                    />
                </>
            )}

            <div className="flex flex-col w-full">
                <div className="relative w-full h-12 overflow-hidden border border-gray-300 rounded-lg bg-basicWhite">
                    <div
                        className="absolute cursor-pointer top-2.5 left-3"
                        onClick={!isSearchIcon ? handleClose : undefined}
                    >
                        <Image
                            src={
                                isSearchIcon
                                    ? '/images/Search.svg'
                                    : '/icons/ChevronLeft.svg'
                            }
                            className="w-6 h-6"
                        />
                    </div>
                    <input
                        type="search"
                        id={id}
                        name={name}
                        ref={searchRef}
                        className="w-full h-full pl-12 border-none outline-none"
                        placeholder={placeholder}
                        onFocus={handleOnFocus}
                        onChange={handleOnChange}
                        autoComplete="off"
                        defaultValue={router.query.search}
                        value={value}
                        onInput={handleOnClear}
                        {...props}
                    />
                </div>
            </div>
            {children}
        </div>
    );
};

export default BondsSearchBar;
